import {
  Actions,
  Subjects,
  useUserAbilitiesContext,
} from 'context/user/UserContext';

export const useCanGenerateLlmReplacements = () => {
  const ability = useUserAbilitiesContext();
  return ability.can(Actions.UseFeature, Subjects.LlmPronunciations);
};

export const useCanLlmRephrase = () => {
  const ability = useUserAbilitiesContext();
  return ability.can(Actions.UseFeature, Subjects.LlmRephrase);
};

export const useCanLlmTranslate = () => {
  const ability = useUserAbilitiesContext();
  return ability.can(Actions.UseFeature, Subjects.LlmTranslation);
};

export const useCanLlmVoiceAudition = () => {
  const ability = useUserAbilitiesContext();
  return ability.can(Actions.UseFeature, Subjects.LlmVoiceAudition);
};
